const state = {
  lang: 'en',
  langDefault: 'en'
}

// getters
const getters = {
  lang: state => state.lang,
  langDefault: state => state.langDefault
}

const mutations = {
  setLang (state, payload) {
    state.lang = payload.lang
  }
}

// actions
const actions = {
  setLang: ({ commit }, params) => {
    commit({ type: 'setLang', lang: params.lang })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
